export function base64ToArrayBufferBlob(tipo: number, base64: string, mime?: string) {
    let datos: any;

    let byteCharacters = atob(base64);
    let byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);

    if (tipo == 1) {// ArrayBuffer
        datos = byteArray;
    } else {// Blob
        let blob = new Blob([byteArray], {type: mime});
        datos = blob;
    }

    return datos;
}

export function getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
}

export function getErrorMesage(errors) {
    let msjError = '';

    if (typeof errors === 'object' && errors !== null) {
        for (let error in errors){
            // msjError += '- '+errors[error][0]+'<br>';
            let arrError = errors[error];
            arrError.forEach(val => {
                msjError += '- '+val+'<br>';
            });
        }
    } else {
        msjError = errors;
    }

    return msjError;
}

export function listarMeses() {
    return [
        {id: 1, nombre: 'Enero'},
        {id: 2, nombre: 'Febrero'},
        {id: 3, nombre: 'Marzo'},
        {id: 4, nombre: 'Abril'},
        {id: 5, nombre: 'Mayo'},
        {id: 6, nombre: 'Junio'},
        {id: 7, nombre: 'Julio'},
        {id: 8, nombre: 'Agosto'},
        {id: 9, nombre: 'Septiembre'},
        {id: 10, nombre: 'Octubre'},
        {id: 11, nombre: 'Noviembre'},
        {id: 12, nombre: 'Diciembre'},
    ];
}

export function rellenarCeros(valor: number|string, cantidad: number) {
    return String(valor).padStart(cantidad, '0');
}